(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accelerated-checkout"] && !Shopify.designMode) return;
  try {
    (() => {
    const containers = document.querySelectorAll('[data-accelerated-checkout-text]');
    if (!containers.length) return;

    for (const container of containers) {
      const customText = container.getAttribute('data-accelerated-checkout-text');
      if (!customText) continue;

      const applyText = () => {
        const button = container.querySelector('.shopify-payment-button__button');
        if (!button) return;

        button.textContent = customText;
      };

      applyText();

      const observer = new MutationObserver(() => {
        applyText();
      });

      observer.observe(container, { childList: true, subtree: true });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["igf-complete-kit"] && !Shopify.designMode) return;
  try {
    class IgfCompleteKit extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('[data-igf-ck-viewport]');
      this.track = this.querySelector('[data-igf-ck-track]');
      this.dotsRoot = this.querySelector('[data-igf-ck-dots]');
      this.cards = [...this.querySelectorAll('[data-igf-ck-card]')];

      if (!this.viewport || this.cards.length === 0) return;

      this.onScroll = () => this.syncDots();
      this.onResize = () => this.buildDots();
      this.viewport.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize, { passive: true });
      this.buildDots();
    }

    disconnectedCallback() {
      if (this.viewport && this.onScroll) {
        this.viewport.removeEventListener('scroll', this.onScroll);
      }
      if (this.onResize) {
        window.removeEventListener('resize', this.onResize);
      }
    }

    columns() {
      const desktop = Number(this.dataset.colsDesktop || 3);
      const mobile = Number(this.dataset.colsMobile || 1);
      return window.matchMedia('(min-width: 750px)').matches ? desktop : mobile;
    }

    pageCount() {
      const cols = Math.max(1, this.columns());
      return Math.ceil(this.cards.length / cols);
    }

    buildDots() {
      if (!this.dotsRoot) return;

      const pages = this.pageCount();
      this.dotsRoot.replaceChildren();

      if (pages <= 1) {
        this.dotsRoot.hidden = true;
        return;
      }

      this.dotsRoot.hidden = false;

      for (let i = 0; i < pages; i++) {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'igf-ck__dot';
        btn.setAttribute('role', 'tab');
        btn.setAttribute('aria-label', String(i + 1));
        btn.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
        btn.addEventListener('click', () => this.goToPage(i));
        this.dotsRoot.appendChild(btn);
      }

      this.syncDots();
    }

    currentPage() {
      const cols = Math.max(1, this.columns());
      const cardWidth = this.cards[0]?.getBoundingClientRect().width || 1;
      const pageWidth = cardWidth * cols;
      return Math.round(this.viewport.scrollLeft / pageWidth);
    }

    goToPage(index) {
      const cols = Math.max(1, this.columns());
      const target = this.cards[index * cols];
      if (!target) return;
      this.viewport.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
    }

    syncDots() {
      if (!this.dotsRoot || this.dotsRoot.hidden) return;
      const active = Math.min(Math.max(this.currentPage(), 0), this.pageCount() - 1);
      const dots = this.dotsRoot.querySelectorAll('.igf-ck__dot');
      dots.forEach((dot, i) => {
        dot.setAttribute('aria-selected', i === active ? 'true' : 'false');
      });
    }
  }

  if (!customElements.get('igf-complete-kit')) {
    customElements.define('igf-complete-kit', IgfCompleteKit);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["igf-trust-bar"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('igf-trust-bar')) {
    class IgfTrustBar extends HTMLElement {
      connectedCallback() {
        this.mq = window.matchMedia('(max-width: 749px)');
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.onChange = () => this.sync();
        this.mq.addEventListener('change', this.onChange);
        this.reduced.addEventListener('change', this.onChange);
        this.sync();
      }

      disconnectedCallback() {
        this.stop();
        this.mq?.removeEventListener('change', this.onChange);
        this.reduced?.removeEventListener('change', this.onChange);
      }

      get items() {
        return Array.from(this.querySelectorAll('.igf-trust-bar__item'));
      }

      sync() {
        this.stop();
        this.style.removeProperty('min-height');
        if (!this.mq.matches || this.reduced.matches) return;

        const layout = this.dataset.mobileLayout;
        const autoplay = this.dataset.autoplay === 'true';
        const interval = Number(this.dataset.interval) || 4000;

        if (layout === 'carousel' && autoplay) {
          this.startCarousel(interval);
        }
      }

      stop() {
        if (this.timer) {
          clearInterval(this.timer);
          this.timer = null;
        }
        if (this._snapRestoreTimer) {
          clearTimeout(this._snapRestoreTimer);
          this._snapRestoreTimer = null;
        }
        this.style.removeProperty('scroll-snap-type');
      }

      /**
       * Scroll horizontal só neste elemento — sem scrollIntoView (salta a página)
       * e sem scroll-snap ativo (browsers podem puxar a viewport para alinhar o snap).
       */
      goToSlide(index) {
        const items = this.items;
        const target = items[index];
        if (!target) return;

        const delta =
          target.getBoundingClientRect().left - this.getBoundingClientRect().left;
        const left = this.scrollLeft + delta;

        this.style.setProperty('scroll-snap-type', 'none');
        this.scrollLeft = left;

        if (this._snapRestoreTimer) clearTimeout(this._snapRestoreTimer);
        this._snapRestoreTimer = setTimeout(() => {
          this.style.removeProperty('scroll-snap-type');
          this._snapRestoreTimer = null;
        }, 50);
      }

      startCarousel(interval) {
        const items = this.items;
        if (items.length < 2) return;

        // Evita salto vertical quando slides têm alturas diferentes
        let maxH = 0;
        for (const item of items) {
          maxH = Math.max(maxH, item.offsetHeight);
        }
        if (maxH > 0) this.style.minHeight = `${maxH}px`;

        let index = 0;
        this.timer = setInterval(() => {
          index = (index + 1) % items.length;
          this.goToSlide(index);
        }, interval);
      }
    }

    customElements.define('igf-trust-bar', IgfTrustBar);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["jv-product-description-excerpt"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.jvProductDescExcerptInited) return;
    window.jvProductDescExcerptInited = true;

    document.addEventListener('click', function (event) {
      const link = event.target.closest('[data-jv-desc-excerpt-link]');
      if (!link) return;

      event.preventDefault();

      const tabs = document.querySelector('.jv-product-tabs');
      if (tabs) {
        tabs.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }

      const descriptionSection = document.querySelector('[data-product-description], .product-description, #product-description');
      if (descriptionSection) {
        descriptionSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
